import React from 'react'
import "./SimilarGames.css"
import "./Body.css"
import GameData from './Data.json'
import similar from './images/Betrayal/similar.jpg'
import Betrayal1 from './images/Betrayal/5.png'
import Betrayal2 from './images/Betrayal/6.png'
import Betrayal3 from './images/Betrayal/7.png'

import CAH1 from './images/CAH/2.jpg'
import CAH2 from './images/CAH/3.jpg'
import CAH3 from './images/CAH/4.jpg'

import Catan1 from './images/Catan/2.jpg'
import Catan2 from './images/Catan/3.jpg'
import Catan3 from './images/Catan/4.jpg'


import EscapeCastle1 from './images/EscapeCastle/2.jpg'
import EscapeCastle2 from './images/EscapeCastle/3.jpg'
import EscapeCastle3 from './images/EscapeCastle/4.jpg'

import SushiGo1 from './images/SushiGo/2.jpg'
import SushiGo2 from './images/SushiGo/3.jpg'
import SushiGo3 from './images/SushiGo/4.png'

import RedDragon1 from './images/RedDragonInn/2.jpg'
import RedDragon2 from './images/RedDragonInn/3.jpg'
import RedDragon3 from './images/RedDragonInn/4.jpg'



import Munchkin1 from './images/Munckin/2.jpg'
import Munchkin2 from './images/Munckin/3.jpg'
import Munchkin3 from './images/Munckin/4.png'

import Hanabi1 from './images/Hanabi/2.jpg'
import Hanabi2 from './images/Hanabi/3.png'
import Hanabi3 from './images/Hanabi/4.png'


function SimilarGames(props) {

    let image1;
    let image2;
    let image3;

    function findGame(GameData) {
        return GameData.title === (props.similar)
    }

    const similarGames = GameData.find(findGame).similarGames;

    switch (props.similar) {
        case 'Betrayal at House on the Hill 3rd Edition':
            image1 = Betrayal1;
            image2 = Betrayal2;
            image3 = Betrayal3;
            break;

        case 'Cards Against Humanity':
            image1 = CAH1;
            image2 = CAH2;
            image3 = CAH3;
            break;

        case 'Catan':
            image1 = Catan1;
            image2 = Catan2;
            image3 = Catan3;
            break;

        case 'Escape The Dark Castle':
            image1 = EscapeCastle1;
            image2 = EscapeCastle2;
            image3 = EscapeCastle3;
            break;

        case 'Munchkin Deluxe':
            image1 = Munchkin1;
            image2 = Munchkin2;
            image3 = Munchkin3;
            break;

        case 'Red Dragon Inn':
            image1 = RedDragon1;
            image2 = RedDragon2;
            image3 = RedDragon3;
            break;

        case 'Sushi Go':
            image1 = SushiGo1;
            image2 = SushiGo2;
            image3 = SushiGo3;
            break;

              case 'Hanabi':
            image1 = Hanabi1;
            image2 = Hanabi2;
            image3 = Hanabi3;
            break;
    }
    return (
        <div>
            <div class="similarGames">
                <img src={similar}></img>
                <div class=" similarText">
                    <h2>Similar Games</h2>
                </div>

            </div>
            <div class="row card-grid">
                <div class="card card-shadow">
                    <div class="card-header card-image">
                        <img src={image1} alt="First slide" />
                    </div>
                    <div class="card-body">
                        {similarGames[0]}
                    </div>

                </div>
                <div class="card card-shadow">
                    <div class="card-header card-image">
                        <img src={image2} alt="First slide" />
                    </div>
                    <div class="card-body">
                        {similarGames[1]}
                    </div>

                </div>

                <div class="card card-shadow">
                    <div class="card-header card-image">
                        <img src={image3} alt="First slide" />
                    </div>
                    <div class="card-body">
                        {similarGames[2]}
                    </div>

                </div>
            </div>

        </div>
    )
}

export default SimilarGames
